<template>
  <div
    class="opple-relate-config"
  >
    <div class="border_title">
      {{ $t('ifttt.associatedConfiguration') }}
    </div>
    <div class="opple-relate-container">
      <NavBar
        :relation-action="relationAction"
        :active-tab="activeTab"
        @onActiveTab="onActiveTab"
      />
      <Platform
        :device="device"
        :active-tab="activeTab"
        :relation-action="relationAction"
        :gp-config="gpConfig"
      />
    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue';
import Platform from '../components/Platform.vue';

export default {
  name: 'OppleRelateConfig',
  components: {
    NavBar,
    Platform
  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    relationAction: {
      type: Array,
      default: () => []
    },
    gpConfig: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: 0
    };
  },

  computed: {

  },

  watch: {
    item(value) {
      this.setCom();
    },
    relationAction(value) {
      console.log('value', value);
    }
  },

  mounted() {
    console.log('relationAction', this.relationAction);
  },

  methods: {
    onActiveTab(tab) {
      this.activeTab = tab;
    }
  },
};
</script>

<style lang="scss">
.opple-relate-config {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;
    
    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: "";
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .opple-relate-container {
    display: flex;
    width: 100%;
    padding: 32px 0;
    justify-content: space-between;
    border: 1px solid #eee;
  }
}

</style>